module.exports = __webpack_public_path__ + "static/design_logo-431b967570ab16a84a112d77f22b8ada.png";